export const ZAC_VERSION = {
    "version": "4.1.2"
};
